import { resetLessonEntry } from 'ducks/workItem';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import { Divider, Fixed, Flex, Heading, Message, Text } from 'rebass';
import { bindActionCreators } from 'redux';
import { Overflow, PvBox, PvButton, PvButtonOutline, BoldLabel} from 'styles/CustomComponents';
import ConfirmButton from '../ConfirmButton';
import Lesson from '../../containers/driving/Lesson';
import uniqueId from 'lodash/uniqueId';
import { findApplicantLessonsAction } from 'ducks/drivingLessons';

class EditDrivingLessonEntryModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      entryEdit: {},
      lessons: []
    };

    const removeClick = () => {
      this.props.removeFn(this.props.applicantId, this.props.lessonEntry.entityId);
    };

    const saveClick = () => {
      const requestObject = {
        lessonEntryEntityId: this.props.lessonEntry.entityId,
        newLesson: this.state.entryEdit,
        lessonStatus: this.state.entryEdit.lessonStatus,
      };
      this.props.saveFn(requestObject);
    };

    const updateEntryEdit = (entryEdit) => {
      this.setState(
        {entryEdit: Object.assign(this.state.entryEdit, entryEdit)}
      );
    };

    const updateLessonPauses = (updatedData) => {
      const newEntryEdit = Object.assign({}, this.state.entryEdit, {lessonPauses: updatedData.lessonPauses});

      this.updateEntryEdit(newEntryEdit);
    };

    const filterLessonList = ({examClass}) => {
      this.setState(
        {
          lessons: this.props.lessons.filter(ld => ld.examClass === examClass)
        }
      );
    };

    this.removeClick = removeClick.bind(this);
    this.saveClick = saveClick.bind(this);
    this.updateEntryEdit = updateEntryEdit.bind(this);
    this.updateLessonPauses = updateLessonPauses.bind(this);
    this.filterLessonList = filterLessonList.bind(this);

    props.findApplicantLessons({applicantId: props.applicantId, course: props.currentCourse});
  }

  componentWillMount() {
    this.setState({
      entryEdit: {
        lessonStatus: this.props.lessonEntry.lessonStatus,
        lessonDate: moment.unix(this.props.lessonEntry.lessonStartTime / 1000).locale('fi'),
        startTime: moment.unix(this.props.lessonEntry.lessonStartTime / 1000).locale('fi').format('HH:mm'),
        endTime: moment.unix(this.props.lessonEntry.lessonEndTime / 1000).locale('fi').format('HH:mm'),
        beneficialDriving: this.props.lessonEntry.beneficialDriving,
        class: this.props.lessonEntry.course.examClasses.map(item => item.name).join(", "),
        subject: this.props.lessonEntry.lesson,
        plateNumber: this.props.lessonEntry.plateNumber || '',
        kilometrage: this.props.lessonEntry.kilometrage || '',
        additionalInfo: this.props.lessonEntry.additionalInfo || '',
        drivingTopicCodes: this.props.lessonEntry.drivingTopicCodes,
        lessonPauses: (!!this.props.lessonEntry.lessonPauses && this.props.lessonEntry.lessonPauses.length > 0) ?
          this.props.lessonEntry.lessonPauses.map((lp) => {
            return {
              entityId: lp.entityId,
              selectedPauseType: lp.lessonPauseType,
              pauseStartTime: moment.unix(lp.pauseStartTime / 1000).locale('fi').format('HH:mm'),
              pauseEndTime: moment.unix(lp.pauseEndTime / 1000).locale('fi').format('HH:mm'),
              id: uniqueId('lessonpause_'),
              errors: {}
            }
          }) : [],
        id: this.props.lessonEntry.entityId,
        errors: {}
      },
      lessons: this.props.lessons.filter(ld => ld.examClass === this.props.lessonEntry.lesson.examClass)
    });
  }

  componentWillUnmount() {
    this.props.resetLessonEntry();
  }

  render() {
    const {
      applicantNameAndTrafiId,
      error,
      hideModal,
      modalType,
      lessonEntry,
      availableLessons,
      lessonTopics
    } = this.props;

    const {entryEdit} = this.state;

    const anyErrors = () => {
      let hasErrors = false;

      if(Object.keys(entryEdit.errors).length > 0){
        hasErrors = true;
        return hasErrors;
      }

      if(!!entryEdit.errors.lessonPauses) {
        entryEdit.errors.lessonPauses.forEach((lp) => {
          if(Object.keys(lp.errors).length > 0) {
            hasErrors = true;
            return hasErrors;
          }
        });
      }

      return hasErrors;
    };

    return (
      <React.Fragment>
        <Fixed
          onClick={() => hideModal()}
          top={0}
          right={0}
          bottom={0}
          left={0}
        />
        <Overflow overflow='auto' p={3} width={['90%', '80%', '70%']}>
          <Heading mb={3} fontSize='19px'><Translate value='app.edit_drivinglesson_entry' /></Heading>

          <Flex flexWrap='wrap'>
            <PvBox w={1 / 2} mb={3}>
              <BoldLabel mb={2}><Translate value='app.name' /></BoldLabel>
              <Text>{applicantNameAndTrafiId}</Text>
            </PvBox>
            <PvBox pl={2} w={1 / 2} mb={3}>
              <BoldLabel mb={2}><Translate value='app.supervisor' /></BoldLabel>
              <Text>{lessonEntry.supervisor}</Text>
            </PvBox>
          </Flex>
          <Flex flexWrap='wrap' alignItems='flex-end'>
            <Lesson
              editMode={true}
              lessonData={this.state.entryEdit}
              examClasses={this.props.examClasses}
              lessonSubjects={this.props.lessons}
              updateLessonPauses= {this.updateLessonPauses}
              pauseTypes={this.props.pauseTypes}
              updateLesson={this.updateEntryEdit}
              generalLoading={this.props.generalLoading}
              showDeleteButton={false}
              availableLessons={availableLessons}
              lessonTopics={lessonTopics}
              addedLessons={this.props.lessons.map(l => l.subject.entityId)}
            />
          </Flex>
          {error && <Message mt={3} bg='red'><Translate value={error} /></Message>}
          <Divider
            my={2}
            w={1}
            borderBottom={2}
            borderColor='grays.1'
          />
          <Text py={2} textAlign='center'>
            <PvButtonOutline
              width='12em'
              my={1}
              ml={2}
              onClick={() => hideModal()}>
              <Translate value='app.cancel' />
            </PvButtonOutline>
            {modalType === 'EDIT_DRIVINGLESSON_ENTRY' &&
            <ConfirmButton
              width='12em'
              my={1}
              ml={2}
              onClick={this.removeClick}>
              <Translate value='app.remove_lesson_entry' />
            </ConfirmButton>
            }
            <PvButton
              width='12em'
              my={1}
              ml={2}
              disabled={anyErrors()}
              onClick={this.saveClick}>
              <Translate value='app.save' />
            </PvButton>
          </Text>
        </Overflow>
      </React.Fragment>
    );
  }
};

EditDrivingLessonEntryModal.propTypes = {
  applicantNameAndTrafiId: PropTypes.string,
  applicantId: PropTypes.number,
  error: PropTypes.string,
  examClasses: PropTypes.array,
  hideModal: PropTypes.func,
  modalType: PropTypes.string,
  lessons: PropTypes.array,
  lessonEntry: PropTypes.object,
  removeFn: PropTypes.func,
  saveFn: PropTypes.func,
  supervisor: PropTypes.string,
  resetLessonEntry: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    pauseTypes: state.general.lessonPauseTypes,
    generalLoading: state.general.loading,
    availableLessons: state.drivingLessons.applicantLessons,
    lessonTopics: state.general.drivingLessonTopics,
    lessons: state.drivingLessons.lessons,
    currentCourse: state.userState.currentCourse,
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  resetLessonEntry: () => resetLessonEntry(),
  findApplicantLessons: (ids) => findApplicantLessonsAction(ids),
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditDrivingLessonEntryModal);


// WEBPACK FOOTER //
// ./src/components/modal/EditDrivingLessonEntryModal.jsx